import { SetupCredentials } from './credentials';
import { SetupMagicLink } from './magic-link';

export const LoginSetup = (nuxt) => {
  SetupCredentials(nuxt);
  SetupMagicLink(nuxt);
};
